export default __webpack_public_path__ + "static/media/lightThemeIcon.00c45c1e.svg";